export enum PlanResourceEnum {
  CASE = "case",
  CLIENT = "client",
  PROVIDER = "provider",
}
